import React, { useState } from "react";
import { allSharedComponents } from "../../../shared";
import CustomModal from "../../../shared/components/CustomModal/CustomModal";

const NewPassword = () => {
  const { GeneralLogo, DontHaveAAccount, NewPassword, BaseForm } =
    allSharedComponents;
  const [isShow, setShow] = useState(true);
  const onSetShow = () => {
    setShow((prev) => !prev);
  };
  return (
    <div className="background-image NewPasswordContainer">
      <CustomModal
        size="sm"
        scrollable={true}
        setShow={onSetShow}
        show={isShow}
        closeBtnClasses={"login-modal-close-btn"}
        isMoveToWP={true}
      >
        <BaseForm>
          <GeneralLogo />
          <NewPassword />
          <DontHaveAAccount />
        </BaseForm>
      </CustomModal>
    </div>
  );
};

export default NewPassword;
